import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HttpBackEnd } from 'src/app/services/httpBackend.service';

export const errorGuard: CanActivateFn = () => {
  const backendService = inject(HttpBackEnd);
  const router = inject(Router);

  if (backendService.isErrorRedirected()) {
    return true;
  } else {
    router.navigate(['/']);
    return false;
  }
};
